import React, {useState} from "react"
import {customerTypeOptions, formTypeOptionsList, issueTimeCustomerOptions} from "./customerSelection"
import Image from "next/image"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Button from "../../reusable/components/Button"
import {useRouter} from "next/router"

enum SelectionType {
    customerTypeSelection = "customerTypeSelection",
    formTypeSelection = "formTypeSelection",
	issueTypeSelection = "issueTypeSelection"
}

interface Props {
    selectionType: keyof typeof SelectionType|string
}

const CustomerTypeSelection:React.FC<Props> = ({
	selectionType
}) => {
	const {t} = useTranslation("kundendienst")
	const [selectedPath, setSelectedPath] = useState("")
	const router = useRouter()

	return (
		<>
			{selectionType === SelectionType.customerTypeSelection ? <>
				{customerTypeOptions?.map((option, index) => {
					const {icon, title, path} = option
					const iconSrc = icon ? selectedPath === path ? icon.replace(".svg", "-white.svg") : icon.replace(".svg", "-black.svg") : null
					return (
						<div key={index}
							className={`${selectedPath === path ? "text-white bg-black" : "text-dark bg-grey"}  rounded py-3 px-4 mb-3 pointer`}
							onClick={() => {
								setSelectedPath(path)
							}}
						>
							<div className={"d-flex align-items-center"}>
								{iconSrc && <Image className="col-3"
									src={iconSrc}
									alt={title}
									height={16}
									width={16} />}
								<Typography
									variant="bodyLg"
									semanticTag="span"
									className="col-9 ms-2"
								>
									{t(title)}
								</Typography>
							</div>

						</div>
					)
				})}

			</> :
				selectionType === SelectionType.formTypeSelection ? <>
					{formTypeOptionsList.map((option, index) => {
						const {icon, title, path} = option
						const iconSrc = icon ? selectedPath === path ? icon.replace(".svg", "-white.svg") : icon.replace(".svg", "-black.svg") : null
						return (
							<div key={index}
								className={`${selectedPath === path ? "text-white bg-black" : "text-dark bg-grey"}  rounded py-3 px-4 mb-3 pointer`}
								onClick={() => {
									setSelectedPath(path)
								}}
							>
								<div className={"d-flex align-items-center"}>
									{iconSrc && <Image className="col-3"
										src={iconSrc}
										alt={title}
										height={16}
										width={16} />}
									<Typography
										variant="bodyLg"
										semanticTag="span"
										className="col-9 ms-2"
									>
										{t(title)}
									</Typography>
								</div>

							</div>
						)
					})}
				</> : <>
					{issueTimeCustomerOptions?.map((option, index) => {
						const {icon, title, path} = option
						const iconSrc = icon ? selectedPath === path ? icon.replace(".svg", "-white.svg") : icon.replace(".svg", "-black.svg") : null
						return (
							<div key={index}
								className={`${selectedPath === path ? "text-white bg-black" : "text-dark bg-grey"}  rounded py-3 px-4 mb-3 pointer`}
								onClick={() => {
									setSelectedPath(path)
								}}
							>
								<div className={"d-flex align-items-center"}>
									{iconSrc && <Image className="col-3"
										src={iconSrc}
										alt={title}
										height={16}
										width={16} />}
									<Typography
										variant="bodyLg"
										semanticTag="span"
										className="col-9 ms-2"
									>
										{t(title)}
									</Typography>
								</div>

							</div>
						)
					})}
				</>}
			<Button
				hoverColor="black"
				outline
				className="mt-3 w-100"
				onClick={() => {
					if (SelectionType.issueTypeSelection === selectionType) {
						if (selectedPath === "more-2-years") {
							router.push("/serviceclient/customer/bike-issue/disclaimer")
						} else {
							router.push("/serviceclient/customer/bike-issue/form")
						}
					} else {
						router.push(selectionType === SelectionType.customerTypeSelection ?
							`/serviceclient/${selectedPath}` :
							`/serviceclient/customer/${selectedPath}`)
					}
				}}
			>
				{t("next")}
			</Button>
		</>
	)
}

export default CustomerTypeSelection
